import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { GrupoService } from './grupo.service';
import { Grupo } from './grupo';

declare var Materialize:any;

@Component({
  selector: 'app-form',
  templateUrl: './form.grupo.component.html',
  providers: [GrupoService]
})
export class FormGrupoComponent implements OnInit, AfterViewChecked {
  public busy: Promise<any>;
  public grupo: Grupo;
  titulo: string = "Grupos";
  public ckeConfig: any;
  ckeditorContent: string = '<p>Some html</p>';
  public options: Object = {
                    placeholderText: 'Digite o rodape aqui',
                    charCounterCount: true
                  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private grupoService: GrupoService
  ) {
    this.grupo = new Grupo();
  }

  getGrupo(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];

      if(id !== undefined ){
        this.busy = this.grupoService.getGrupo(id)
          .then(grupo => this.grupo = grupo );
      }
    });
  }

  salvar(): void {
    this.busy = this.grupoService.saveGrupo(this.grupo)
            .then(() => this.goBack());
  }

  upload(event: any):void{
    let listaArquivo: FileList = event.target.files;
    let arquivo: File = listaArquivo[0];
    this.grupo.imagem_rodape = arquivo;
  }

  goBack(): void {
     this.router.navigate(['/grupos']);
  }

  ngOnInit() {
    this.getGrupo();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/grupos/form.grupo.component.ts